module.exports = __webpack_public_path__ + "static/media/panda-commerce.b25e7b4a.jpg";